
// import React , {useState,useEffect} from "react";
// import { FaChartLine, FaExclamationTriangle, FaFileInvoice, FaMoneyBill, FaShoppingCart, FaUndo,  FaClipboardList,  FaRupeeSign,  FaChartBar,  FaHistory,} from "react-icons/fa";
// import {FaTruck,FaTags,} from "react-icons/fa";
// import { FaBoxes, FaMoneyBillWave, FaUsers, FaChartPie,} from "react-icons/fa";
// import { useNavigate } from 'react-router-dom';
// import axios from'axios'
// import { showError } from "../../General/Toast.js";
// import { hasPermission } from "./Permission";



// const Home = ({clientData}) => {
//   const navigate = useNavigate();
//   // ==============================
//   // STAFF PERMISSION
//   // ==============================
//   const handleBillingNavigate = (path) => {
//   if (!hasPermission("billing")) {
//     showError(
//       "You don't have permission to access Billing"
//     );
//     return;
//   }

//   navigate(path);
// };

// //  const getUserData = () => {
// //   try {
// //     return JSON.parse(
// //       localStorage.getItem("user_data") || "{}"
// //     );
// //   } catch (error) {
// //     console.error("Invalid user_data:", error);
// //     return {};
// //   }
// // };

// // const getActions = (userData) => {
// //   let actions = userData?.actions || [];

// //   try {
// //     while (typeof actions === "string") {
// //       actions = JSON.parse(actions);
// //     }
// //   } catch (error) {
// //     console.error("Invalid staff actions:", error);
// //     return [];
// //   }

// //   if (!Array.isArray(actions)) {
// //     return [];
// //   }

// //   return actions.map((action) =>
// //     String(action).toLowerCase().trim()
// //   );
// // };

// // const hasPermission = (permission) => {
// //   const userData = getUserData();

// //   const role = String(userData?.role || "")
// //     .toLowerCase()
// //     .trim();


// //   if (
// //     role === "owner" ||
// //     role === "admin"
// //   ) {
// //     return true;
// //   }

// //   const actions = getActions(userData);

// //   return actions.includes(
// //     String(permission).toLowerCase().trim()
// //   );
// // };

// const handlePermissionNavigate = (
//   permission,
//   path,
//   message
// ) => {
//   if (!hasPermission(permission)) {
//     showError(
//       message ||
//       `You don't have permission to access ${permission}`
//     );
//     return;
//   }

//   navigate(path);
// };



//   const isMobile = window.innerWidth < 768;
//   const [hoveredCard, setHoveredCard] = React.useState(null);
//   const [lowStock, setLowStock] = useState([]);
//   const[saleBill,setSaleBill] = useState([]);
//   const [todaySales, setTodaySales] = useState(0);
//     const [purchaseBill, setPurchaseBill] = useState([]);
//     const [todayPurchase, setTodayPurchase] = useState(0);

// // const clientId = clientData.id
// const clientId = clientData?.id;
//   const cardStyle = {
//     background: "#fff",
//     borderRadius: "20px",
//     padding: "20px",
//     boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
//     border: "1px solid #e5e7eb",
//   };

// // const menuBox = {
// //   background: "#fff",
// //   borderRadius: "15px",
// //   padding: "20px",
// //   textAlign: "center",
// //   cursor: "pointer",
// //   border: "1px solid #e5e7eb",
// //   boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
// //   transition: "all 0.3s ease",
// //   position: "relative",
// //   overflow: "hidden",
// // };
// const menuBox = {
//   background: "#fff",
//   borderRadius: "15px",
//   padding: "20px",
//   textAlign: "center",
//   cursor: "pointer",
//   border: "1px solid #e5e7eb",
//   boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
//   transition: "all 0.3s ease",
//   position: "relative",
//   overflow: "hidden",

//   // IMPORTANT: equal card size
//   width: "100%",
//   minWidth: 0,
//   minHeight: "125px",
//   boxSizing: "border-box",

//   // content center
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   justifyContent: "center",
// };
//   const sectionCard = {
//     background: "#fff",
//     borderRadius: "20px",
//     padding: "20px",
//     border: "1px solid #e5e7eb",
//     boxShadow: "0 10px 25px rgba(0,0,0,.08)",
//   };

// const fetchLowStock = async () => {
//   try {
 
//     await new Promise(resolve => setTimeout(resolve, 2000));
//     const res = await axios.get(
//       `http://localhost:5000/fetch-inventory/${clientId}`
//     );

//     const filteredData = res.data.filter(
//       (item) => Number(item.stock) <= Number(item.min_to_maintain)
//     );

//     setLowStock(filteredData);
//   } catch (error) {
//     console.log(error);
//   }
// };

// const fetchSaleHistory = async () => {
//   try {
//     const res = await axios.get(
//       `http://localhost:5000/fetch-sale-history/${clientData.id}`
//     );

//     const sortedData = [...res.data].sort(
//       (a, b) => b.invoiceNo - a.invoiceNo
//     );

//     setSaleBill(sortedData);


//     const today = new Date().toLocaleDateString("en-CA");

//     const todaysSales = res.data.filter((sale) => {
//       const saleDate = sale.date?.split(" ")[0];

//       return saleDate === today;
//     });

//     // Calculate today's total sales
//     const totalToday = todaysSales.reduce((total, sale) => {
//       return total + Number(sale.totalSP || 0);
//     }, 0);

//     setTodaySales(totalToday);

//   } catch (error) {
//     console.log(error);
//   }
// };


// const fetchPurchase = async () => {
//   try {
//     const res = await axios.get(
//       `http://localhost:5000/fetch-purchase-bill/${clientData.id}`
//     );

//     const sortedData = [...res.data].sort(
//       (a, b) => b.id - a.id
//     );

//     setPurchaseBill(sortedData);

//     // Today's date
//     const today = new Date().toLocaleDateString("en-CA");

//     // Filter today's purchases
//     const todaysPurchases = res.data.filter((purchase) => {
//       const purchaseDate = purchase.date?.split(" ")[0];

//       return purchaseDate === today;
//     });


//     // Calculate today's purchase total
//     const totalTodayPurchase = todaysPurchases.reduce(
//       (total, purchase) => {
//         return total + Number(purchase.payable || 0);
//       },
//       0
//     );

//     setTodayPurchase(totalTodayPurchase);

//   } catch (error) {
//     console.log(error);
//   }
// };




// useEffect(() => {
//   fetchLowStock();
//   fetchSaleHistory();
//   fetchPurchase();
// }, []);


//   return (
// <div
//   style={{
//     width: "100%",
//     maxWidth: "100%",
//     overflowX: "hidden",
//     boxSizing: "border-box",
//      padding: "20px",
//   }}
// >

  
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: isMobile
//             ? "1fr"
//             : "repeat(4,1fr)",
//           gap: "20px",
//           marginBottom: "25px",
//              padding: "0 20px 20px 20px",
//         }}
//       >
//         <div style={cardStyle}>
//           <p>Today's Sales</p>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//             }}
//           >
//              <h2>₹{todaySales.toLocaleString("en-IN", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     })}</h2>
//             <FaChartLine size={35} color="#22c55e" />
//           </div>
//         </div>

//         <div style={cardStyle}>
//           <p>Today's Purchase</p>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//             }}
//           >
//           <h2>
//       ₹
//       {todayPurchase.toLocaleString("en-IN", {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//       })}
//     </h2>
//             <FaChartBar size={35} color="#3b82f6" />
//           </div>
//         </div>

//         <div style={cardStyle}
//           onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/sale-history",
//     "You don't have permission to access Billing"
//   )
// }
//         >
//           <p>Invoices</p>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//             }}
        
//           >
//             <h2>{saleBill.length} </h2>
//             <FaFileInvoice size={35} color="#06b6d4" />
//           </div>
//         </div>

//         <div style={cardStyle}>
//           <p>Low Stock</p>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//             }}
//           >
//             <h2>{lowStock.length} </h2>
//             <FaExclamationTriangle size={35} color="#ef4444" />
//           </div>
//         </div>
//       </div>

//       {/* Dashboard Sections */}
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: isMobile
//             ? "1fr"
//             : "repeat(2,1fr)",
//           gap: "20px",
//         }}
//       >
//         {/* Sales */}
//         <div style={sectionCard}>
//        <div style={{ textAlign: "center" }}>
//   {/* <button
//     style={{
//     width: "200px",
// padding: "10px 18px",
//       border: "none",
//       borderRadius: "30px",
//       color: "#fff",
//       fontWeight: "bold",
//       background: "linear-gradient(135deg,#22c55e,#16a34a)",
//       cursor: "pointer",
//     }}
//   >
//     + ADD SALE
//   </button> */}
// <button 
//   onClick={() =>
//     handlePermissionNavigate(
//       "billing",
//       "/add-sale",
//       "You don't have permission to access Billing"
//     )
//   }
//   style={{ 
//     width: "200px", 
//     padding: "10px 18px", 
//     border: "none", 
//     borderRadius: "30px", 
//     color: "#fff", 
//     fontWeight: "bold", 
//     background: "linear-gradient(135deg,#22c55e,#16a34a)", 
//     cursor: "pointer", 
//   }} 
// > 
//   + ADD SALE 
// </button>
// </div>

//      <div
//   style={{
//     display: "grid",
//     gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
//     gridAutoRows: "1fr",
//     gap: "15px",
//     marginTop: "20px",
//     width: "100%",
//     alignItems: "stretch",
//   }}
// >
//         <div
//   onMouseEnter={() => setHoveredCard("saleInvoice")}
//   onMouseLeave={() => setHoveredCard(null)}
//   style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "saleInvoice"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "saleInvoice"
//         ? "0 15px 35px rgba(34,197,94,0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }}
//   //  onClick={() => navigate('/add-sale')}
//   onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/add-sale",
//     "You don't have permission to access Billing"
//   )
// }
// >
//   <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "saleInvoice"
//           ? "rgba(34,197,94,0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "saleInvoice"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
   
//   >
//     <FaClipboardList size={30} color="#22c55e" />
//   </div>

//   <p>Sale Invoice</p>
// </div>

//          <div
//   onMouseEnter={() => setHoveredCard("paymentIn")}
//   onMouseLeave={() => setHoveredCard(null)}
//   style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "paymentIn"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "paymentIn"
//         ? "0 15px 35px rgba(34, 59, 197, 0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }}

//   //  onClick={() => navigate('/payment-in-history')}
//   onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/payment-in-history",
//     "You don't have permission to access Billing"
//   )
// }
// >
//   <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "paymentIn"
//           ? "rgba(34, 37, 197, 0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "paymentIn"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
   
//   >
//  <FaMoneyBill size={30} color="#3b82f6" />
//   </div>

//   <p>Payment In</p>
// </div>
//                     <div
//   onMouseEnter={() => setHoveredCard("saleReturn")}
//   onMouseLeave={() => setHoveredCard(null)}
//   style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "saleReturn"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "saleReturn"
//         ? "0 15px 35px rgba(197, 34, 34, 0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }}
//   onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/sale-return",
//     "You don't have permission to access Billing"
//   )
// }
// >
//   <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "saleReturn"
//           ? "rgba(216, 76, 76, 0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "saleReturn"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
//   >
//  <FaUndo size={30} color="#ef4444" />
//   </div>

//   <p>Sale Return</p>
// </div>
//                               <div
//   onMouseEnter={() => setHoveredCard("SaleHistory")}
//   onMouseLeave={() => setHoveredCard(null)}
//   style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "SaleHistory"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "SaleHistory"
//         ? "0 15px 35px rgba(194, 197, 34, 0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }}
//   onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/sale-history",
//     "You don't have permission to access Billing"
//   )
// }
//   //  onClick={() => navigate('/sale-history')}
// >
//   <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "SaleHistory"
//           ? "rgba(34,197,94,0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "SaleHistory"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
//   >
//    <FaHistory size={30} color="#f59e0b" />
//   </div>

//     <p>Sale History</p>
// </div>
// </div>
// </div>

//         {/* Purchase */}
//             <div style={sectionCard}>
//        <div style={{ textAlign: "center" }}>
// <button
// onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/addpurchase",
//     "You don't have permission to access Billing"
//   )
// }
//   style={{
//     width: "200px",
//     padding: "10px 18px",
//     border: "none",
//     borderRadius: "30px",
//     color: "#fff",
//     fontWeight: "bold",
//     background: "linear-gradient(135deg,#ef4444,#dc2626)",
//     cursor: "pointer",
//   }}
// >
//   + ADD PURCHASE
// </button>
// </div>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr",
//               gap: "15px",
//               marginTop: "20px",
//             }}
//           >
//                                      <div
//   onMouseEnter={() => setHoveredCard("purchasebill")}
//   onMouseLeave={() => setHoveredCard(null)}
//   style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "purchasebill"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "purchasebill"
//         ? "0 15px 35px rgba(178, 34, 197, 0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }}
//     onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/purchase",
//     "You don't have permission to access Billing"
//   )
// }
// >
//   <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "purchasebill"
//           ? "rgba(34,197,94,0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "purchasebill"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
//   >
//       <FaShoppingCart size={30} color="#8b5cf6" />
//   </div>

//           <p>Purchase Bill</p>
// </div>


//            <div
//   onMouseEnter={() => setHoveredCard("Purchasereturn")}
//   onMouseLeave={() => setHoveredCard(null)}
//   style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "Purchasereturn"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "Purchasereturn"
//         ? "0 15px 35px rgba(197, 34, 34, 0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }}
//     onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/purchaseReturn",
//     "You don't have permission to access Billing"
//   )
// }
// >
//   <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "Purchasereturn"
//           ? "rgba(197, 40, 34, 0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "Purchasereturn"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
//   >
//   <FaUndo size={30} color="#ef4444" />
//   </div>

//             <p>Purchase Return</p>
// </div>


//           <div
//   onMouseEnter={() => setHoveredCard("Purchasehistory")}
//   onMouseLeave={() => setHoveredCard(null)}
//   style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "Purchasehistory"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "Purchasehistory"
//         ? "0 15px 35px rgba(194, 197, 34, 0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }}
//   //  onClick={() => navigate('/purchase')}
//   onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/purchase",
//     "You don't have permission to access Billing"
//   )
// }
// >
//   <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "Purchasehistory"
//           ? "rgba(197, 194, 34, 0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "Purchasehistory"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
//   >
// <FaHistory size={30} color="#f59e0b" />
//   </div>

//             <p>Purchase History</p>
// </div>


//             <div 
//              onMouseEnter={() => setHoveredCard("PurchasereturnHis")}
//   onMouseLeave={() => setHoveredCard(null)}
//           //  onClick={() => navigate('/purchase-return-history')}
//           onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/purchase-return-history",
//     "You don't have permission to access Billing"
//   )
// }
//             style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "PurchasereturnHis"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "PurchasereturnHis"
//         ? "0 15px 35px rgba(197, 34, 34, 0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }}
//            >

//               <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "PurchasereturnHis"
//           ? "rgba(197, 40, 34, 0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "PurchasereturnHis"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
//   >
//               <FaHistory size={30} color="#3b82f6" />
// </div>

//               <p>Return History</p>
//             </div>


//           </div>
//         </div>

//         {/* Estimate */}
//                 <div style={sectionCard}>
//        <div style={{ textAlign: "center" }}>
//   {/* <button
//     style={{
//     width: "200px",
// padding: "10px 18px",
//       border: "none",
//       borderRadius: "30px",
//       color: "#fff",
//       fontWeight: "bold",


// background:
//                 "linear-gradient(135deg,#f59e0b,#d97706)",
//       cursor: "pointer",
//     }}
//   >
//     + ADD ESTIMATE
//   </button> */}
//   <button
// onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/add-estimate",
//     "You don't have permission to access Billing"
//   )
// }
//   style={{
//     width: "200px",
//     padding: "10px 18px",
//     border: "none",
//     borderRadius: "30px",
//     color: "#fff",
//     fontWeight: "bold",
//     background: "linear-gradient(135deg,#22c55e,#16a34a)",
//     cursor: "pointer",
//   }}
// >
//   + ADD ESTIMATE
// </button>
// </div>
//         <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr",
//               gap: "15px",
//               marginTop: "15px",
//             }}
           
//           >
//             <div 
//                onMouseEnter={() => setHoveredCard("estimate")}
//   onMouseLeave={() => setHoveredCard(null)}
//   style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "estimate"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "estimate"
//         ? "0 15px 35px rgba(197, 34, 34, 0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }}
//                     onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/add-estimate",
//     "You don't have permission to access Billing"
//   )
// }
//             // onClick={() => navigate('/add-estimate')}
//             >
//               <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "estimate"
//           ? "rgba(197, 40, 34, 0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "Purchasereturn"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
//   >
//               <FaFileInvoice size={35} color="#d0b8e6"  />
// </div>
//               <p>Make Estimate</p>
//             </div>

//             <div 
//               onMouseEnter={() => setHoveredCard("estimateHistory")}
//   onMouseLeave={() => setHoveredCard(null)}
//   style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "estimateHistory"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "estimateHistory"
//         ? "0 15px 35px rgba(197, 34, 34, 0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }}
//                    onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/estimate-history",
//     "You don't have permission to access Billing"
//   )
// }   
//             // onClick={() => navigate('/estimate-history')}
//             >

// <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "estimateHistory"
//           ? "rgba(197, 40, 34, 0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "Purchasereturn"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
//   >
//           <FaHistory size={35} color="#d9f09a" />
// </div>

//               <p>Estimate History</p>
//             </div>

//             <div 
            
//              onMouseEnter={() => setHoveredCard("Purchasereturn")}
//   onMouseLeave={() => setHoveredCard(null)}
//   style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "Purchasereturn"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "Purchasereturn"
//         ? "0 15px 35px rgba(197, 34, 34, 0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }}
//           onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/estimate-to-sale",
//     "You don't have permission to access Billing"
//   )
// }
//             // onClick={() => navigate('/estimate-to-sale')}
//             >


//                 <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "Purchasereturn"
//           ? "rgba(197, 40, 34, 0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "Purchasereturn"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
//   >
//               <FaClipboardList size={35} color="#afe7c0" />
// </div>


//               <p>Convert To Sale</p>
//             </div>

//             <div 

//              onMouseEnter={() => setHoveredCard("expense")}
//   onMouseLeave={() => setHoveredCard(null)}
//   style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "expense"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "expense"
//         ? "0 15px 35px rgba(197, 34, 34, 0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }}

//       onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/expenses",
//     "You don't have permission to access Billing"
//   )
// }
//             >

//            <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "expense"
//           ? "rgba(197, 40, 34, 0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "Purchasereturn"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
//   >
//               <FaRupeeSign size={35}  color="#448eef"/>

// </div>

//               <p>Add Expenses</p>
//             </div>

//           </div>
//         </div>
      
        



//         {/* Product */}
//         <div style={sectionCard}>
//        <div style={{ textAlign: "center" }}>
//  <button
// onClick={() =>
//   handlePermissionNavigate(
//     "inventory",
//     "/items",
//     "You don't have permission to access Inventory"
//   )
// }
//   style={{
//     width: "200px",
//     padding: "10px 18px",
//     border: "none",
//     borderRadius: "30px",
//     color: "#fff",
//     fontWeight: "bold",
//     background: "linear-gradient(135deg,#3b82f6,#2563eb)",
//     cursor: "pointer",
//   }}
// >
//   + ADD PRODUCT
// </button>
// </div>

       
//            <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr",
//               gap: "15px",
//               marginTop: "15px",
//             }}
//           >


//             <div 
//              onMouseEnter={() => setHoveredCard("delivery-invoice")}
//   onMouseLeave={() => setHoveredCard(null)}
//   style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "delivery-invoice"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "delivery-invoice"
//         ? "0 15px 35px rgba(197, 34, 34, 0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }} 
//   onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/challan-invoice",
//     "You don't have permission to access Billing"
//   )
// }
//               //  onClick={() => navigate('/challan-invoice')}
//             >

//    <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "delivery-invoice"
//           ? "rgba(197, 40, 34, 0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "delivery-invoice"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
//   >
//           <FaTruck size={35} color="#3b82f6" />
//               </div>
              
              
//               <p>Delivery invoice</p>
//             </div>

//             <div 
//               onMouseEnter={() => setHoveredCard("challan-history")}
//   onMouseLeave={() => setHoveredCard(null)}
//   style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "challan-history"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "challan-history"
//         ? "0 15px 35px rgba(197, 34, 34, 0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }} 
//             // onClick={() => navigate('/challan-list')}
//                       onClick={() =>
//   handlePermissionNavigate(
//     "billing",
//     "/challan-list",
//     "You don't have permission to access Billing"
//   )
// }
//             >

//                <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "challan-history"
//           ? "rgba(197, 40, 34, 0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "challan-history"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
//   >
//                   <FaHistory size={35} color="#f59e0b" />
//         </div>
//               <p>Challan History</p>
//             </div>

//             <div 
//              onMouseEnter={() => setHoveredCard("sale-ret-history")}
//   onMouseLeave={() => setHoveredCard(null)}
//   style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "sale-ret-history"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "sale-ret-history"
//         ? "0 15px 35px rgba(197, 34, 34, 0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }} 
//   onClick={() =>
//   handlePermissionNavigate(
//     "Billing",
//     "/sale-return-history",
//     "You don't have permission to access Billling"
//   )
// }
//             // onClick={() => navigate('/sale-return-history')}
//             >

//                  <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "sale-ret-history"
//           ? "rgba(197, 40, 34, 0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "sale-ret-history"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
//   > 
//                    <FaUndo size={35} color="#f5690b" />
//          </div>
//               <p>Sale Ret History</p>
//             </div>

//             <div onMouseEnter={() => setHoveredCard("offer")}
//   onMouseLeave={() => setHoveredCard(null)}
//   style={{
//     ...menuBox,
//     transform:
//       hoveredCard === "offer"
//         ? "translateY(-8px) scale(1.04)"
//         : "translateY(0)",
//     boxShadow:
//       hoveredCard === "offer"
//         ? "0 15px 35px rgba(197, 34, 34, 0.35)"
//         : "0 4px 10px rgba(0,0,0,0.05)",
//   }} 
//             onClick={() => navigate('/sale-return-history')}
             
//             >

//                 <div
//     style={{
//       width: "65px",
//       height: "65px",
//       borderRadius: "50%",
//       background:
//         hoveredCard === "offer"
//           ? "rgba(197, 40, 34, 0.15)"
//           : "rgba(34,197,94,0.08)",
//       margin: "0 auto 10px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "all 0.3s ease",
//       transform:
//         hoveredCard === "offer"
//           ? "rotate(10deg) scale(1.15)"
//           : "scale(1)",
//     }}
//   > 
//                    <FaTags size={35} color="#5d0bf5" />
//          </div>
//               <p>Reports</p>
//             </div>
           
//           </div>
//         </div>

//       </div>

//        <div
//   style={{
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
//     gap: "20px",
//     marginTop: "25px",
//   }}
// >
//   <div
//     style={{
//       background: "linear-gradient(135deg,#3b82f6,#2563eb)",
//       color: "#fff",
//       borderRadius: "18px",
//       padding: "20px",
//       textAlign: "center",
//       boxShadow: "0 10px 25px rgba(155, 186, 236, 0.25)",
//       cursor: "pointer",
//     }}
//     //  onClick={() => navigate('/items')}
//               onClick={() =>
//   handlePermissionNavigate(
//     "Inventory",
//     "/items",
//     "You don't have permission to access Inventory"
//   )
// }
//   >
//     <FaBoxes size={35} />
//     <p style={{ marginTop: "10px" }}>Inventory</p>
//   </div>

//   <div
//     style={{
//       background: "linear-gradient(135deg,#10b981,#059669)",
//       color: "#fff",
//       borderRadius: "18px",
//       padding: "20px",
//       textAlign: "center",
//       boxShadow: "0 10px 25px rgba(158, 241, 214, 0.25)",
//       cursor: "pointer",
//     }}
// //               onClick={() =>
// //   handlePermissionNavigate(
// //     "billing",
// //     "/cashinhand",
// //     "You don't have permission to access Billing"
// //   )
// // }
//      onClick={() => navigate('/cashinhand')}
//   >
//     <FaMoneyBillWave size={35} />
//     <p style={{ marginTop: "10px" }}>Cash Flow</p>
//   </div>

//   <div
//     style={{
//       background: "linear-gradient(135deg,#f59e0b,#d97706)",
//       color: "#fff",
//       borderRadius: "18px",
//       padding: "20px",
//       textAlign: "center",
//       boxShadow: "0 10px 25px rgba(245, 217, 169, 0.25)",
//       cursor: "pointer",
//     }}
//        onClick={() => navigate('/bankaccount')}
// //                 onClick={() =>
// //   handlePermissionNavigate(
// //     "billing",
// //     "/backaccount",
// //     "You don't have permission to access Billing"
// //   )
// // }
//   >
    
//     <FaUsers size={35} />
//     <p style={{ marginTop: "10px" }}>Accounts</p>
//   </div>

//   <div
//     style={{
//       background: "linear-gradient(135deg,#8b5cf6,#7c3aed)",
//       color: "#fff",
//       borderRadius: "18px",
//       padding: "20px",
//       textAlign: "center",
//       boxShadow: "0 10px 25px rgba(211, 202, 235, 0.25)",
//       cursor: "pointer",
//     }}
//   onClick={() =>
//   handlePermissionNavigate(
//     "reports",
//     "/reports",
//     "You don't have permission to access Reports"
//   )
// }
//   >
//     <FaChartPie size={35} />
//     <p style={{ marginTop: "10px" }}>Reports</p>
//   </div>
// </div>
     
//     </div>
    
//   );
// };

// export default Home;





import React, { useState, useEffect } from "react";
import {
  FaChartLine,
  FaExclamationTriangle,
  FaFileInvoice,
  FaMoneyBill,
  FaShoppingCart,
  FaUndo,
  FaClipboardList,
  FaRupeeSign,
  FaChartBar,
  FaHistory,
} from "react-icons/fa";

import { FaTruck, FaTags } from "react-icons/fa";
import {
  FaBoxes,
  FaMoneyBillWave,
  FaUsers,
  FaChartPie,
} from "react-icons/fa";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { showError } from "../../General/Toast.js";
import { hasPermission } from "./Permission";
const ActionCard = ({
  title,
  subtitle,
  icon,
  iconColor = "#2563eb",
  bg = "#eff6ff",
  onClick,
}) => {
  return (
    <div
      className="dashboard-action-card"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <div
        className="action-icon"
        style={{
          background: bg,
          color: iconColor,
        }}
      >
        {icon}
      </div>

      <div className="action-card-content">
        <strong>{title}</strong>

        {subtitle && (
          <span>{subtitle}</span>
        )}
      </div>

      <div className="action-arrow">
        →
      </div>
    </div>
  );
};


const Home = ({ clientData }) => {
  const navigate = useNavigate();

  // ==============================
  // STAFF PERMISSION
  // ==============================

  const handleBillingNavigate = (path) => {
    if (!hasPermission("billing")) {
      showError(
        "You don't have permission to access Billing"
      );
      return;
    }

    navigate(path);
  };

  const handlePermissionNavigate = (
    permission,
    path,
    message
  ) => {
    if (!hasPermission(permission)) {
      showError(
        message ||
          `You don't have permission to access ${permission}`
      );
      return;
    }

    navigate(path);
  };

  // ==============================
  // STATES
  // ==============================

  const isMobile = window.innerWidth < 768;

  const [hoveredCard, setHoveredCard] =
    React.useState(null);

  const [lowStock, setLowStock] = useState([]);
  const [saleBill, setSaleBill] = useState([]);
  const [todaySales, setTodaySales] = useState(0);

  const [purchaseBill, setPurchaseBill] =
    useState([]);

  const [todayPurchase, setTodayPurchase] =
    useState(0);

  const clientId = clientData?.id;

  // ==============================
  // CARD STYLES
  // ==============================

  const cardStyle = {
    background: "#fff",
    borderRadius: "20px",
    padding: "20px",
    boxShadow:
      "0 10px 25px rgba(0,0,0,0.08)",
    border: "1px solid #e5e7eb",
  };

  const menuBox = {
    background: "#fff",
    borderRadius: "15px",
    padding: "20px",
    textAlign: "center",
    cursor: "pointer",
    border: "1px solid #e5e7eb",
    boxShadow:
      "0 4px 10px rgba(0,0,0,0.05)",
    transition: "all 0.3s ease",
    position: "relative",
    overflow: "hidden",

    width: "100%",
    minWidth: 0,
    minHeight: "125px",
    boxSizing: "border-box",

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  };

  const sectionCard = {
    background: "#fff",
    borderRadius: "20px",
    padding: "20px",
    border: "1px solid #e5e7eb",
    boxShadow:
      "0 10px 25px rgba(0,0,0,.08)",
  };

  // ==============================
  // LOW STOCK
  // ==============================

  const fetchLowStock = async () => {
    try {
      await new Promise((resolve) =>
        setTimeout(resolve, 2000)
      );

      const res = await axios.get(
        `http://localhost:5000/fetch-inventory/${clientId}`
      );

      const filteredData = res.data.filter(
        (item) =>
          Number(item.stock) <=
          Number(item.min_to_maintain)
      );

      setLowStock(filteredData);
    } catch (error) {
      console.log(error);
    }
  };
const getGreeting = () => {
  const hour = new Date().getHours();

  if (hour >= 5 && hour < 12) {
    return "Good Morning";
  }

  if (hour >= 12 && hour < 17) {
    return "Good Afternoon";
  }

  if (hour >= 17 && hour < 21) {
    return "Good Evening";
  }

  return "Good Night";
};
  // ==============================
  // SALE HISTORY
  // ==============================

  const fetchSaleHistory = async () => {
    try {
      const res = await axios.get(
        `http://localhost:5000/fetch-sale-history/${clientData.id}`
      );

      const sortedData = [...res.data].sort(
        (a, b) => b.invoiceNo - a.invoiceNo
      );

      setSaleBill(sortedData);

      const today =
        new Date().toLocaleDateString("en-CA");

      const todaysSales = res.data.filter(
        (sale) => {
          const saleDate =
            sale.date?.split(" ")[0];

          return saleDate === today;
        }
      );

      const totalToday =
        todaysSales.reduce(
          (total, sale) =>
            total +
            Number(sale.totalSP || 0),
          0
        );

      setTodaySales(totalToday);
    } catch (error) {
      console.log(error);
    }
  };

  // ==============================
  // PURCHASE
  // ==============================

  const fetchPurchase = async () => {
    try {
      const res = await axios.get(
        `http://localhost:5000/fetch-purchase-bill/${clientData.id}`
      );

      const sortedData = [...res.data].sort(
        (a, b) => b.id - a.id
      );

      setPurchaseBill(sortedData);

      const today =
        new Date().toLocaleDateString("en-CA");

      const todaysPurchases =
        res.data.filter((purchase) => {
          const purchaseDate =
            purchase.date?.split(" ")[0];

          return purchaseDate === today;
        });

      const totalTodayPurchase =
        todaysPurchases.reduce(
          (total, purchase) =>
            total +
            Number(purchase.payable || 0),
          0
        );

      setTodayPurchase(
        totalTodayPurchase
      );
    } catch (error) {
      console.log(error);
    }
  };

  // ==============================
  // FETCH DATA
  // ==============================

  useEffect(() => {
    fetchLowStock();
    fetchSaleHistory();
    fetchPurchase();
  }, []);

  // ==============================
  // MAIN UI
  // ==============================

  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        background: "#f5f8fc",
        padding: isMobile
          ? "8px"
          : "18px",
        boxSizing: "border-box",
        overflowX: "hidden",
        fontFamily:
          "Inter, Arial, sans-serif",
      }}
    >
      {/* =========================
          WELCOME / BUSINESS HEADER
      ========================== */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile
            ? "minmax(0, 3.2fr) minmax(88px, 1fr)"
            : "minmax(0, 2.2fr) minmax(240px, 1fr)",
          gap: "8px",
          marginBottom: "10px",
        }}
      >
        <div
          style={{
            background:
              "linear-gradient(135deg,#eef7ff,#f8fbff)",
            border:
              "1px solid #e3ebf5",
            borderRadius: "10px",
            padding: isMobile
              ? "10px 12px"
              : "14px 18px",
            minHeight: isMobile
              ? "54px"
              : "68px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent:
                "space-between",
              gap: "10px",
            }}
          >
            <div
              style={{
                minWidth: 0,
              }}
            >
       <h5
  style={{
    margin: 0,
    fontSize: isMobile ? "14px" : "18px",
    fontWeight: 800,
    color: "#14213d",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }}
>
  {getGreeting()},{" "}
  {clientData?.business_name || "Dectwin"}! 👋
</h5>

              <p
                style={{
                  margin:
                    "4px 0 0",
                  fontSize: isMobile
                    ? "9px"
                    : "11px",
                  color: "#64748b",
                }}
              >
                Quick access to
                everything you need.
              </p>
            </div>

            {!isMobile && (
              <div
                style={{
                  textAlign: "right",
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    fontSize: "9px",
                    color: "#64748b",
                  }}
                >
                  {new Date().toLocaleDateString(
                    "en-IN",
                    {
                      weekday: "long",
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }
                  )}
                </div>

                <strong
                  style={{
                    fontSize: "14px",
                    color: "#1e3155",
                  }}
                >
                  {new Date().toLocaleTimeString(
                    "en-IN",
                    {
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}
                </strong>
              </div>
            )}
          </div>
        </div>

        <div
          style={{
            background:
              "linear-gradient(135deg,#edf6ff,#ffffff)",
            border:
              "1px solid #e3ebf5",
            borderRadius: "10px",
            padding: "9px 12px",
            minHeight: isMobile
              ? "48px"
              : "68px",
            display: "flex",
            alignItems: "center",
            justifyContent:
              "center",
            textAlign: "center",
          }}
        >
          <div>
            <div
              style={{
                fontSize: isMobile
                  ? "9px"
                  : "11px",
                fontWeight: 800,
                color: "#2456a6",
              }}
            >
              “Simple Billing
            </div>

            <div
              style={{
                fontSize: isMobile
                  ? "9px"
                  : "11px",
                fontWeight: 800,
                color: "#2456a6",
              }}
            >
              Bigger Business.”
            </div>

            <div
              style={{
                fontSize: "8px",
                color: "#64748b",
                marginTop: "2px",
              }}
            >
              — Dectwin
            </div>
          </div>
        </div>
      </div>
            {/* =========================
          QUICK ACTIONS HEADER
      ========================== */}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "7px",
          padding: "0 3px",
        }}
      >
        <h6
          style={{
            margin: 0,
            fontSize: isMobile ? "11px" : "14px",
            fontWeight: 800,
            color: "#17243b",
          }}
        >
           Quick Actions
        </h6>

        <button
          type="button"
          style={{
            border: "1px solid #dbe4ef",
            background: "#fff",
            borderRadius: "7px",
            padding: isMobile
              ? "4px 8px"
              : "6px 10px",
            fontSize: isMobile ? "8px" : "10px",
            fontWeight: 600,
            color: "#344054",
            cursor: "pointer",
          }}
        >
          ⚙ Customize
        </button>
      </div>

      {/* =========================
          QUICK ACTIONS
      ========================== */}
{/* =========================================================
    BUSINESS ACTION CARDS
========================================================= */}

<div className="dashboard-action-wrapper">

  {/* ================= SALES ================= */}

  <div className="action-section">

    <div className="action-section-header sales-header">
      <div>
        <h5>Sales</h5>
        <span>Manage sales & customer payments</span>
      </div>

      <button
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/add-sale",
            "You don't have permission to access Billing"
          )
        }
      >
        + New Sale
      </button>
    </div>

    <div className="action-grid">

      {/* ADD SALE */}
      <ActionCard
        title="Add Sale"
        subtitle="Create invoice"
        icon={<FaShoppingCart />}
        iconColor="#16a34a"
        bg="#ecfdf5"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/add-sale",
            "You don't have permission to access Billing"
          )
        }
      />

      {/* PAYMENT IN */}
      <ActionCard
        title="Payment In"
        subtitle="Receive payment"
        icon={<FaMoneyBill />}
        iconColor="#0891b2"
        bg="#ecfeff"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/payment-in-history",
            "You don't have permission to access Billing"
          )
        }
      />

      {/* SALE RETURN */}
      <ActionCard
        title="Sale Return"
        subtitle="Return invoice"
        icon={<FaUndo />}
        iconColor="#dc2626"
        bg="#fef2f2"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/sale-return",
            "You don't have permission to access Billing"
          )
        }
      />

      {/* SALE HISTORY */}
      <ActionCard
        title="Sale History"
        subtitle="View all sales"
        icon={<FaHistory />}
        iconColor="#2563eb"
        bg="#eff6ff"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/sale-history",
            "You don't have permission to access Billing"
          )
        }
      />

      {/* SALE RETURN HISTORY */}
      <ActionCard
        title="Sale Return History"
        subtitle="View returned sales"
        icon={<FaHistory />}
        iconColor="#ea580c"
        bg="#fff7ed"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/sale-return-history",
            "You don't have permission to access Billing"
          )
        }
      />

    </div>
  </div>


  {/* ================= PURCHASE ================= */}

  <div className="action-section">

    <div className="action-section-header purchase-header">
      <div>
        <h5>Purchase</h5>
        <span>Manage purchases & supplier payments</span>
      </div>

      <button
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/addpurchase",
            "You don't have permission to access Billing"
          )
        }
      >
        + New Purchase
      </button>
    </div>

    <div className="action-grid">

      {/* PURCHASE BILL */}
      <ActionCard
        title="Purchase Bill"
        subtitle="Create purchase"
        icon={<FaShoppingCart />}
        iconColor="#7c3aed"
        bg="#f5f3ff"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/addpurchase",
            "You don't have permission to access Billing"
          )
        }
      />

      {/* PURCHASE RETURN */}
      <ActionCard
        title="Purchase Return"
        subtitle="Return purchase"
        icon={<FaUndo />}
        iconColor="#dc2626"
        bg="#fef2f2"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/purchaseReturn",
            "You don't have permission to access Billing"
          )
        }
      />

      {/* PURCHASE HISTORY */}
      <ActionCard
        title="Purchase History"
        subtitle="View purchases"
        icon={<FaHistory />}
        iconColor="#2563eb"
        bg="#eff6ff"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/purchase",
            "You don't have permission to access Billing"
          )
        }
      />

      {/* PURCHASE RETURN HISTORY */}
      <ActionCard
        title="Return History"
        subtitle="View purchase returns"
        icon={<FaHistory />}
        iconColor="#ea580c"
        bg="#fff7ed"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/purchase-return-history",
            "You don't have permission to access Billing"
          )
        }
      />

      {/* PAYMENT OUT */}
      <ActionCard
        title="Payment Out"
        subtitle="Pay supplier"
        icon={<FaRupeeSign />}
        iconColor="#9333ea"
        bg="#faf5ff"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/expenses",
            "You don't have permission to access Billing"
          )
        }
      />

    </div>
  </div>


  {/* ================= ESTIMATE ================= */}

  <div className="action-section">

    <div className="action-section-header estimate-header">
      <div>
        <h5>Estimates</h5>
        <span>Create quotations and convert them into sales</span>
      </div>

      <button
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/add-estimate",
            "You don't have permission to access Billing"
          )
        }
      >
        + New Estimate
      </button>
    </div>

    <div className="action-grid">

      {/* MAKE ESTIMATE */}
      <ActionCard
        title="Make Estimate"
        subtitle="Create quotation"
        icon={<FaFileInvoice />}
        iconColor="#d97706"
        bg="#fffbeb"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/add-estimate",
            "You don't have permission to access Billing"
          )
        }
      />

      {/* ESTIMATE HISTORY */}
      <ActionCard
        title="Estimate History"
        subtitle="View quotations"
        icon={<FaHistory />}
        iconColor="#2563eb"
        bg="#eff6ff"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/estimate-history",
            "You don't have permission to access Billing"
          )
        }
      />

      {/* CONVERT TO SALE */}
      <ActionCard
        title="Convert To Sale"
        subtitle="Estimate → Invoice"
        icon={<FaClipboardList />}
        iconColor="#16a34a"
        bg="#ecfdf5"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/estimate-to-sale",
            "You don't have permission to access Billing"
          )
        }
      />

    </div>
  </div>


  {/* ================= EXPENSE / DELIVERY ================= */}

  <div className="action-section">

    <div className="action-section-header other-header">
      <div>
        <h5>Other Business Actions</h5>
        <span>Expenses, delivery and business reports</span>
      </div>
    </div>

    <div className="action-grid">

      {/* EXPENSE */}
      <ActionCard
        title="Add Expense"
        subtitle="Record expense"
        icon={<FaRupeeSign />}
        iconColor="#9333ea"
        bg="#faf5ff"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/expenses",
            "You don't have permission to access Billing"
          )
        }
      />

      {/* DELIVERY */}
      <ActionCard
        title="Delivery Invoice"
        subtitle="Create challan"
        icon={<FaTruck />}
        iconColor="#2563eb"
        bg="#eff6ff"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/challan-invoice",
            "You don't have permission to access Billing"
          )
        }
      />

      {/* CHALLAN HISTORY */}
      <ActionCard
        title="Challan History"
        subtitle="View delivery challans"
        icon={<FaHistory />}
        iconColor="#d97706"
        bg="#fffbeb"
        onClick={() =>
          handlePermissionNavigate(
            "billing",
            "/challan-list",
            "You don't have permission to access Billing"
          )
        }
      />

      {/* REPORTS */}
      <ActionCard
        title="Reports"
        subtitle="Business reports"
        icon={<FaChartPie />}
        iconColor="#7c3aed"
        bg="#f5f3ff"
        onClick={() =>
          handlePermissionNavigate(
            "reports",
            "/reports",
            "You don't have permission to access Reports"
          )
        }
      />

    </div>
  </div>

</div>
            {/* =========================
          RECENT ACTIVITY
      ========================== */}

      <div
        style={{
          background: "#fff",
          borderRadius: "10px",
          border: "1px solid #e5ebf3",
          boxShadow:
            "0 3px 12px rgba(25,45,75,.06)",
          overflow: "hidden",
          marginBottom: "12px",
        }}
      >
        {/* HEADER */}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: isMobile
              ? "9px 10px"
              : "13px 15px",
            borderBottom:
              "1px solid #edf1f5",
          }}
        >
          <h6
            style={{
              margin: 0,
              fontSize: isMobile
                ? "11px"
                : "14px",
              fontWeight: 800,
              color: "#17243b",
            }}
          >
            ◉ Recent Activity
          </h6>

          <button
            type="button"
            onClick={() =>
              handlePermissionNavigate(
                "billing",
                "/sale-history",
                "You don't have permission to access Billing"
              )
            }
            style={{
              border: "none",
              background: "transparent",
              color: "#2563eb",
              fontSize: isMobile
                ? "7px"
                : "9px",
              fontWeight: 700,
              cursor: "pointer",
              padding: 0,
            }}
          >
            View All →
          </button>
        </div>

        {/* TABLE HEADER */}

<div
  style={{
    display: "grid",
    gridTemplateColumns:
      "1fr 1.2fr 1.2fr 1fr 1fr 1.1fr",
    alignItems: "center",
    background: "#f8fafc",
    borderBottom: "1px solid #edf1f5",
    padding: isMobile ? "8px 8px" : "9px 12px",
    fontSize: isMobile ? "10px" : "13px",
    fontWeight: 700,
    color: "#64748b",
  }}
>
  <span>Type</span>
  <span>Reference</span>
  <span>Party</span>
  <span>Amount</span>
  <span>Status</span>
  <span>Date</span>
</div>

        {/* =========================
            SALE
        ========================== */}

        {saleBill.length > 0 ? (
          saleBill.slice(0, 5).map(
            (sale, index) => (
              <div
                key={`sale-${sale.id || index}`}
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    "1fr 1.2fr 1.2fr 1fr 1fr 1.1fr",
                  alignItems: "center",
                  padding: isMobile
                    ? "7px 8px"
                    : "9px 12px",
                  borderBottom:
                    "1px solid #f0f2f5",
                  fontSize: isMobile
                    ? "6px"
                    : "8px",
                  color: "#344054",
                }}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <span
                    style={{
                      width: isMobile
                        ? "15px"
                        : "20px",
                      height: isMobile
                        ? "15px"
                        : "20px",
                      borderRadius: "4px",
                      background: "#dcfce7",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaShoppingCart
                      size={
                        isMobile
                          ? 7
                          : 10
                      }
                      color="#16a34a"
                    />
                  </span>

                  <span>Sale</span>
                </span>

                <span
                  style={{
                    fontWeight: 600,
                  }}
                >
                  #{sale.invoiceNo || "N/A"}
                </span>

                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    paddingRight: "4px",
                  }}
                >
                  {sale.customerName ||
                    sale.customer_name ||
                    sale.partyName ||
                    "Walk-in Customer"}
                </span>

                <span
                  style={{
                    fontWeight: 700,
                  }}
                >
                  ₹
                  {Number(
                    sale.totalSP || 0
                  ).toLocaleString(
                    "en-IN",
                    {
                      minimumFractionDigits: 2,
                    }
                  )}
                </span>

                <span
                  style={{
                    width: "fit-content",
                    background: "#dcfce7",
                    color: "#15803d",
                    borderRadius: "10px",
                    padding: "3px 7px",
                    fontWeight: 700,
                  }}
                >
                  Paid
                </span>

                <span>
                  {sale.date ||
                    "-"}
                </span>
              </div>
            )
          )
        ) : (
          <div
            style={{
              padding: isMobile
                ? "18px 8px"
                : "25px",
              textAlign: "center",
              color: "#94a3b8",
              fontSize: isMobile
                ? "8px"
                : "10px",
            }}
          >
            No recent sale transactions
            found
          </div>
        )}

        {/* =========================
            PURCHASE
        ========================== */}

        {purchaseBill.length > 0 &&
          purchaseBill
            .slice(0, 5)
            .map((purchase, index) => (
              <div
                key={`purchase-${
                  purchase.id || index
                }`}
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    "1fr 1.2fr 1.2fr 1fr 1fr 1.1fr",
                  alignItems: "center",
                  padding: isMobile
                    ? "7px 8px"
                    : "9px 12px",
                  borderBottom:
                    "1px solid #f0f2f5",
                  fontSize: isMobile
                    ? "6px"
                    : "8px",
                  color: "#344054",
                }}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <span
                    style={{
                      width: isMobile
                        ? "15px"
                        : "20px",
                      height: isMobile
                        ? "15px"
                        : "20px",
                      borderRadius: "4px",
                      background: "#ffe4e6",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaShoppingCart
                      size={
                        isMobile
                          ? 7
                          : 10
                      }
                      color="#ef4444"
                    />
                  </span>

                  <span>Purchase</span>
                </span>

                <span
                  style={{
                    fontWeight: 600,
                  }}
                >
                  #
                  {purchase.invoiceNo ||
                    purchase.billNo ||
                    purchase.id ||
                    "N/A"}
                </span>

                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    paddingRight: "4px",
                  }}
                >
                  {purchase.supplierName ||
                    purchase.supplier_name ||
                    purchase.partyName ||
                    "Walk-in Customer"}
                </span>

                <span
                  style={{
                    fontWeight: 700,
                  }}
                >
                  ₹
                  {Number(
                    purchase.payable || 0
                  ).toLocaleString(
                    "en-IN",
                    {
                      minimumFractionDigits: 2,
                    }
                  )}
                </span>

                <span
                  style={{
                    width: "fit-content",
                    background: "#fef3c7",
                    color: "#d97706",
                    borderRadius: "10px",
                    padding: "3px 7px",
                    fontWeight: 700,
                  }}
                >
                  Pending
                </span>

                <span>
                  {purchase.date ||
                    "-"}
                </span>
              </div>
            ))}
      </div>

      {/* =========================
          RESPONSIVE STYLE
      ========================== */}

    <style>
{`
/* =========================================================
   DASHBOARD ACTION SECTIONS
========================================================= */

.dashboard-action-wrapper {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 12px;

  /* IMPORTANT: prevents empty stretched area */
  align-items: start;
}

.action-section {
  width: 100%;
  min-width: 0;
  height: fit-content;
  align-self: start;

  background: #ffffff;
  border: 1px solid #e5ebf3;
  border-radius: 14px;
  padding: 14px;

  box-shadow: 0 4px 14px rgba(25, 45, 75, 0.05);

  overflow: hidden;
}


/* =========================================================
   SECTION HEADER
========================================================= */

.action-section-header {
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 10px;
  margin-bottom: 12px;
  padding-bottom: 10px;

  border-bottom: 1px solid #edf1f5;
}

.action-section-header > div {
  min-width: 0;
  flex: 1;
}

.action-section-header h5 {
  margin: 0;

  font-size: 14px;
  line-height: 1.2;
  font-weight: 800;

  color: #17243b;
}

.action-section-header span {
  display: block;

  margin-top: 3px;

  font-size: 9px;
  line-height: 1.3;

  color: #64748b;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.action-section-header button {
  flex-shrink: 0;

  border: none;
  border-radius: 7px;

  padding: 7px 11px;

  background: #17243b;
  color: #ffffff;

  font-size: 9px;
  font-weight: 700;

  cursor: pointer;
  white-space: nowrap;

  transition: all 0.2s ease;
}

.action-section-header button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
}


/* SECTION BUTTON COLORS */

.sales-header button {
  background: linear-gradient(
    135deg,
    #22c55e,
    #16a34a
  );
}

.purchase-header button {
  background: linear-gradient(
    135deg,
    #ef4444,
    #dc2626
  );
}

.estimate-header button {
  background: linear-gradient(
    135deg,
    #f59e0b,
    #d97706
  );
}


/* =========================================================
   ACTION GRID
========================================================= */

.action-grid {
  width: 100%;

  display: grid;

  grid-template-columns:
    repeat(2, minmax(0, 1fr));

  gap: 9px;

  align-items: start;
}


/* =========================================================
   ACTION CARD
========================================================= */

.dashboard-action-card {
  width: 100%;
  min-width: 0;
  min-height: 78px;

  padding: 10px;

  border: 1px solid #e7ecf2;
  border-radius: 11px;

  background: #ffffff;

  display: flex;
  align-items: center;

  gap: 9px;

  cursor: pointer;

  position: relative;

  box-sizing: border-box;

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease,
    background 0.2s ease;
}

.dashboard-action-card:hover {
  transform: translateY(-2px);

  border-color: #d7e0eb;

  box-shadow:
    0 7px 18px rgba(25, 45, 75, 0.08);

  background: #fcfdff;
}

.dashboard-action-card:active {
  transform: translateY(0);
}


/* =========================================================
   ICON
========================================================= */

.action-icon {
  width: 39px;
  height: 39px;
  min-width: 39px;

  border-radius: 10px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 16px;

  flex-shrink: 0;
}


/* =========================================================
   CARD CONTENT
========================================================= */

.action-card-content {
  min-width: 0;
  flex: 1;
  overflow: hidden;
}

.action-card-content strong {
  display: block;

  font-size: 11px;
  line-height: 1.2;

  color: #243044;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.action-card-content span {
  display: block;

  margin-top: 4px;

  font-size: 8px;
  line-height: 1.2;

  color: #718096;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


/* =========================================================
   ARROW
========================================================= */

.action-arrow {
  flex-shrink: 0;

  color: #94a3b8;

  font-size: 13px;
  font-weight: 700;

  transition: transform 0.2s ease;
}

.dashboard-action-card:hover .action-arrow {
  transform: translateX(2px);
}


/* =========================================================
   LARGE TABLET
========================================================= */

@media (max-width: 1100px) {

  .dashboard-action-wrapper {
    grid-template-columns: 1fr;
  }

}


/* =========================================================
   TABLET
========================================================= */

@media (max-width: 991px) {

  .dashboard-action-wrapper {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .action-section {
    padding: 12px;
  }

  .action-grid {
    grid-template-columns:
      repeat(2, minmax(0, 1fr));
  }

}


/* =========================================================
   MOBILE
========================================================= */

@media (max-width: 767px) {

  .dashboard-action-wrapper {
    width: 100%;

    display: grid;
    grid-template-columns: 1fr;

    gap: 9px;

    margin-top: 8px;

    align-items: start;
  }

  .action-section {
    width: 100%;

    padding: 9px;

    border-radius: 10px;

    height: fit-content;
  }


  /* HEADER */

  .action-section-header {
    gap: 6px;

    margin-bottom: 8px;
    padding-bottom: 8px;
  }

  .action-section-header h5 {
    font-size: 11px;
  }

  .action-section-header span {
    font-size: 7px;
  }

  .action-section-header button {
    padding: 5px 7px;

    border-radius: 6px;

    font-size: 7px;
  }


  /* CARDS */

  .action-grid {
    grid-template-columns:
      repeat(2, minmax(0, 1fr));

    gap: 6px;
  }

  .dashboard-action-card {
    min-height: 65px;

    padding: 7px;

    gap: 6px;

    border-radius: 8px;
  }


  /* ICON */

  .action-icon {
    width: 29px;
    height: 29px;
    min-width: 29px;

    border-radius: 8px;

    font-size: 12px;
  }


  /* TEXT */

  .action-card-content strong {
    font-size: 8px;
  }

  .action-card-content span {
    font-size: 6px;

    margin-top: 2px;
  }


  /* ARROW */

  .action-arrow {
    font-size: 9px;
  }

}


/* =========================================================
   VERY SMALL MOBILE
========================================================= */

@media (max-width: 380px) {

  .action-section {
    padding: 8px;
  }

  .action-grid {
    gap: 5px;
  }

  .dashboard-action-card {
    min-height: 60px;

    padding: 6px;

    gap: 5px;
  }

  .action-icon {
    width: 26px;
    height: 26px;
    min-width: 26px;

    font-size: 10px;
  }

  .action-card-content strong {
    font-size: 10px;
  }

  .action-card-content span {
    font-size: 6.5px;
  }

  .action-arrow {
    font-size: 10px;
  }

}
  /* =========================================================
   MOBILE - RECENT ACTIVITY VISIBILITY FIX
========================================================= */

@media (max-width: 767px) {

  /* Give dashboard enough bottom space for fixed bottom nav */
  .dashboard-action-wrapper {
    margin-bottom: 10px;
  }

  /* Recent Activity */
  .dashboard-action-wrapper + div {
    margin-bottom: 75px !important;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  /* Recent Activity Header */
  .dashboard-action-wrapper + div h6 {
    font-size: 11px !important;
  }

  /* Recent Activity table */
  .dashboard-action-wrapper + div > div {
    max-width: 100%;
  }
}
`}

</style>
    </div>
  );
};

export default Home;

